export const QUERY_KEY_GROUPS_INFINITE = 'QUERY_KEY_GROUPS_INFINITE'
export const QUERY_KEY_GROUPS_PAGINATED = 'QUERY_KEY_GROUPS_PAGINATED'
export const QUERY_KEY_GROUP = 'QUERY_KEY_GROUP'
export const QUERY_KEY_DEPARTMENT_LEVEL = 'QUERY_KEY_DEPARTMENT_LEVEL'
export const QUERY_KEY_DEPARTMENTS_SEARCH = 'QUERY_KEY_DEPARTMENTS_SEARCH'
export const QUERY_KEY_GROUP_MEMBER_COUNT = 'QUERY_KEY_GROUP_MEMBER_COUNT'
export const MUTATION_KEY_ADD_USER_TO_GROUP = 'MUTATION_KEY_ADD_USER_TO_GROUP'
export const MUTATION_KEY_UPDATE_GROUP = 'MUTATION_KEY_UPDATE_GROUP'
export const MUTATION_KEY_CREATE_GROUP = 'MUTATION_KEY_CREATE_GROUP'
export const MUTATION_KEY_DELETE_GROUP = 'MUTATION_KEY_DELETE_GROUP'
